import {formatCurrency, formatNumber} from '@angular/common';

import { DetailScreen } from '../mapping-classes/detail-screen';
import { DetailPanel } from '../mapping-classes/detail-panel';
import { DetailLabel } from '../mapping-classes/detail-label';
import { ButtonData } from '../mapping-classes/button-data';

export class Importletterofcredit implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = 'Import Letter of Credit';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.title = response.detailsViewObject.commercialProductTypeName || 'Import Letter of Credit';
      this.actualityDateTime = response.detailsViewObject.actualityDateTime;
      this.addButtons(response);
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      if (response.detailsViewObject && response.detailsViewObject.restrictedData) {
        this.restrictedData = response.detailsViewObject.restrictedData;
      }
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues();
      this.addValues(response);
    }
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    this.panels.push(new DetailPanel('Productgebruik'));
  }

  setNameAndValues() {
    let product: DetailPanel = this.panels[0];
    this.fillProductFeatures(product);

    product = this.panels[1];
    this.fillProductAgreements(product);

    product = this.panels[2];
    this.fillProductUsage(product);
  }

  addValues(response: any) {
    const obj = response.detailsViewObject;
    let productDetailsPanel: DetailPanel = this.panels[0];
    this.addValuesToProductFeatures(productDetailsPanel, obj);

    productDetailsPanel = this.panels[1];
    this.addValuesToProductAgreements(productDetailsPanel, obj);

    productDetailsPanel = this.panels[2];
    this.addValuesToProductUsage(productDetailsPanel, obj);

  }

  addButtons(response) {
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductFeatures(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('referenceNumber', new DetailLabel('Referentienummer'));
    productDetailsPanel.nameAndValues.set('lcType', new DetailLabel('Type L/C'));
    productDetailsPanel.nameAndValues.set('applicantPartyName', new DetailLabel('Koper'));
    productDetailsPanel.nameAndValues.set('importLc', new DetailLabel('Soort Accreditief'));
    productDetailsPanel.nameAndValues.set('cashCoverInd', new DetailLabel('Zekerheid'));
    productDetailsPanel.nameAndValues.set('beneficiaryPartyName', new DetailLabel('Verkoper'));
  }

  private addValuesToProductFeatures(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('referenceNumber').setValue(obj.referenceNumber || '-');
    productDetailsPanel.nameAndValues.get('lcType').setValue(obj.lcType || '-');
    productDetailsPanel.nameAndValues.get('applicantPartyName').setValue(obj.applicantPartyName || '-');
    productDetailsPanel.nameAndValues.get('importLc').setValue('Import L/C');
    productDetailsPanel.nameAndValues.get('cashCoverInd').setValue(obj.cashCoverInd || '-');
    productDetailsPanel.nameAndValues.get('beneficiaryPartyName').setValue(obj.beneficiaryPartyName || '-');
  }

  private fillProductAgreements(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('startDate', new DetailLabel('Openingsdatum'));
    productDetailsPanel.nameAndValues.set('lcAmountInEur', new DetailLabel( 'L/C Bedrag EUR'));
    productDetailsPanel.nameAndValues.set('lcAmount', new DetailLabel('L/C Bedrag VV')); //formating number concatenate
   // productDetailsPanel.nameAndValues.set('maximumAccount', new DetailLabel('Max. Bedrag VV'));
    productDetailsPanel.nameAndValues.set('ratePercentage', new DetailLabel('Accreditief provisie %'));
    productDetailsPanel.nameAndValues.set('advisingBankPartyName', new DetailLabel(' Adviserende Bank'));
    productDetailsPanel.nameAndValues.set('advisingBankCountryName', new DetailLabel('Land van de bank'));
    productDetailsPanel.nameAndValues.set('expiryDate', new DetailLabel('Vervaldatum'));
    productDetailsPanel.nameAndValues.set('endDate', new DetailLabel('Einddatum'));
    productDetailsPanel.nameAndValues.set('latestShipmentDate', new DetailLabel('Laatste levering'));
  }

  private addValuesToProductAgreements(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('startDate').setValue(obj.startDate || '-');
    productDetailsPanel.nameAndValues.get('lcAmountInEur')
      .setValue((obj.lcAmountInEur && formatCurrency(obj.lcAmountInEur, 'nl', '€')) || '-');
    productDetailsPanel.nameAndValues.get('advisingBankPartyName').setValue(obj.advisingBankPartyName || '-');
    productDetailsPanel.nameAndValues.get('expiryDate').setValue(obj.expiryDate || '-');
    productDetailsPanel.nameAndValues.get('lcAmount').setValue(
      this.numberFormat(obj.lcAmount,obj.lcAmountCurrencyCode) || '-');
    productDetailsPanel.nameAndValues.get('advisingBankCountryName').setValue(obj.advisingBankCountryName || '-');
    productDetailsPanel.nameAndValues.get('endDate').setValue(obj.endDate || '-');
   // productDetailsPanel.nameAndValues.get('maximumAccount').setValue(obj.maximumAccount || '-');
    productDetailsPanel.nameAndValues.get('latestShipmentDate').setValue(obj.latestShipmentDate || '-');
    productDetailsPanel.nameAndValues.get('ratePercentage').setValue(obj.ratePercentage || '-');
  }

  private fillProductUsage(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('openAmountInEur', new DetailLabel('Openstaand bedrag EUR'));
    productDetailsPanel.nameAndValues.set('openAmount', new DetailLabel('Openstaand bedrag VV'));
    productDetailsPanel.nameAndValues.set('commissioningLatestDate', new DetailLabel('Datum laatste afrekening'));
    productDetailsPanel.nameAndValues.set('commissioningLatestAmount', new DetailLabel('Bedrag laatste afrekening'));
    productDetailsPanel.nameAndValues.set('feeAccount', new DetailLabel('Kosten afgerekend op'));
    productDetailsPanel.nameAndValues.set('numberOfDeliveries', new DetailLabel('Aantal deelleveringen'));
    productDetailsPanel.nameAndValues.set('liabiltyAccount', new DetailLabel('Rekening ingeperkt'));
  }

  private addValuesToProductUsage(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('openAmountInEur').setValue((obj.openAmountInEur &&
      formatCurrency(obj.openAmountInEur, 'nl', '€')) || '-');
    productDetailsPanel.nameAndValues.get('feeAccount').setValue(obj.feeAccount || '-');
    productDetailsPanel.nameAndValues.get('numberOfDeliveries').setValue(obj.numberOfDeliveries || '-');
    productDetailsPanel.nameAndValues.get('openAmount').setValue(
      this.numberFormat(obj.openAmount,obj.openAmountCurrencyCode) || '-'); //just number concatenate
    productDetailsPanel.nameAndValues.get('liabiltyAccount').setValue(obj.liabiltyAccount || '-');
    productDetailsPanel.nameAndValues.get('commissioningLatestDate').setValue(obj.commissioningLatestDate || '-');
    productDetailsPanel.nameAndValues.get('commissioningLatestAmount').setValue(
      this.numberFormat(obj.commissioningLatestAmount,obj.commissioningLatestAmountCurrencyCode) || '-');
  }

  private addSubHeaderToPanel(panel: DetailPanel, title) {
    panel.subPanels.push(new DetailPanel(title));
  }

  public numberFormat(num: number, currency: string) {
    if (!(num && currency)) {
      return null;
    }
    return `${formatNumber(num, 'nl-NL', '2.2-5')} ${currency}`
  }

}
